import PropTypes from 'prop-types';
import React from 'react';

const PlusIcon = ({ size }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 3.969 3.969"
  >
    <path
      d="M.644 2.628a.644.644 0 0 1 0-1.287h.697V.644a.643.643 0 1 1 1.287 0v.697h.697a.644.644 0 0 1 0 1.287h-.697v.697a.643.643 0 0 1-1.287 0v-.697z"
      fill="#e85e85"
    />
  </svg>
);

PlusIcon.propTypes = {
  size: PropTypes.number,
};

PlusIcon.defaultProps = {
  size: 15,
};

export default PlusIcon;
